const ArrowCaseOpening = () => (
  <svg
    width="18px"
    height="12px"
    viewBox="0 0 18 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Icon/16px_Functional/Arrow_Blue</title>
    <g
      id="HM_SP"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <g
        id="00.0-/-Claim-/-Onboarding"
        transform="translate(-298.000000, -486.000000)"
        stroke="#FFFFFF"
        strokeWidth="2"
      >
        <g
          id="Icon/16px_Functional/Arrow_Blue"
          transform="translate(299.000000, 487.500000)"
        >
          <line
            x1="7.66666667"
            y1="-2.33333333"
            x2="7.66666667"
            y2="11.6666667"
            id="Line"
            transform="translate(7.666667, 4.666667) rotate(-90.000000) translate(-7.666667, -4.666667) "
          ></line>
          <polyline
            id="Line"
            transform="translate(13.865125, 4.666667) rotate(-90.000000) translate(-13.865125, -4.666667) "
            points="9.19845794 2.80154206 13.8651246 6.53179128 18.5317913 2.80154206"
          ></polyline>
        </g>
      </g>
    </g>
  </svg>
);

export default ArrowCaseOpening;
